import React from "react";
import Image from "../../components/Image";

const WhyChooseUs = () => {
  return (
    <section className="Revolutionising py-[50px] md:py-[110px] bg-cf-light-grey table-section-grey why-choose-us-grey">
      <div className="container block md:flex justify-between items-start">
        <div className="w-full md:max-w-[439px]">
          <h3 className="text-[24px] md:text-[28px] font-semibold text-cf-hero max-w-[495px] mb-[16px] md:leading-[39px] md:mt-[40px]">
            Why choose us?
          </h3>
          <p className="max-w-[398px] pb-5 text-[15px]">
            Your Trusted Partner in all Transactions
          </p>
        </div>
        <div
          style={{ backgroundColor: "#F4F5FE" }}
          className="w-full md:w-[771px] mt-[20px] md:mt-0 p-[0px] md:px-[25px] md:py-[10px] rounded">
          <Image
            src="https://cashfreelogo.cashfree.com/website/landings/escrow-account/Table_desktop.png"
            alt="table"
            className="hidden md:block"
            width="721"
            height="860"
          />
          <Image
            src="https://cashfreelogo.cashfree.com/website/landings/escrow-account/Table_mweb.png"
            alt="table"
            className="block md:hidden"
            width="686"
            height="1304"
          />
        </div>
      </div>
      <div className="md:max-w-[1258px] m-auto mt-[70px] py-[20px] md:py-[0px]">
        <div className="bg-purple-small">
          <div className="md:text-[24px] text-[20px] font-semibold max-w-[247px] md:max-w-[502px] m-auto md:m-[2px]">
            Curious to know how One{" "}
            <h2 className="inline md:text-[24px] text-[20px] font-semibold body-text">
              Escrow
            </h2>{" "}
            can be a game-changer for your business?
          </div>
          <a
            className="button button-green w-full md:w-[178px]"
            style={{ height: "fit-content", marginTop: "20px" }}
            href="/contact-sales?source-action=One%20Escrow&action=Contact%20Sales&button-id=ContactSales_CuriousToKnow">
            Schedule Call <span className="chevron" />
          </a>
        </div>
      </div>
    </section>
  );
};
export default WhyChooseUs;
